import { languageConfig } from "~/config/language.config";

export const cleanStringsConcat = (strings) => {
  return strings
    .join(" ")
    .replace(/ +(?= )/g, "")
    .trim();
};

export const getFullName = (name) => {
  return cleanStringsConcat([
    name.lastName,
    name.firstName,
    name.middleName ? name.middleName : "",
  ]);
};

export const unlocalizeRouteName = (routeName) =>
  routeName.replace(/^[a-z]+_/, "");

export const unlocalizeUrl = (url) => {
  const locales = languageConfig.map(({ synonym }) => synonym);
  const regexp = new RegExp(`^/(${locales.join("|")})(/|$)`);

  return url.replace(regexp, "/");
};

export const urlify = (text) => {
  const urlRegex =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,512}\.[a-z]{2,6}\b([-a-zA-Z0-9:%_+~#&/=]*)/g;

  const withLineBreak = text.replace(/\r\n|\r|\n/g, "<br>");

  return withLineBreak.replace(
    urlRegex,
    (url) =>
      '<a href="' + url + '" style="word-break: break-word">' + url + "</a>",
  );
};
